import { Avatar, AvatarFallback } from "@do/ui/components/avatar";
import { cn } from "@do/ui/lib/utils";
import { HeadsetIcon } from "lucide-react";

export const AdvisorAvatar = ({ isHeader = false }: { isHeader?: boolean }) => {
  return (
    <div className="relative size-fit">
      <Avatar
        className={cn(
          isHeader
            ? cn(
                "size-(--header-advisor-avatar-size)",
                "rounded-(--header-advisor-avatar-border-radius)",
                "border-(--header-advisor-avatar-border-color)/(--header-advisor-avatar-border-opacity) border-(length:--header-advisor-avatar-border-width)",
                "bg-(--header-advisor-avatar-background)/(--header-advisor-avatar-background-opacity)"
              )
            : cn(
                "size-(--message-advisor-avatar-size)",
                "rounded-(--message-advisor-avatar-border-radius)",
                "border-(--message-advisor-avatar-border-color)/(--message-advisor-avatar-border-opacity) border-(length:--message-advisor-avatar-border-width)",
                "bg-(--message-advisor-avatar-background)/(--message-advisor-avatar-background-opacity)"
              )
        )}
      >
        <AvatarFallback
          className={cn(
            isHeader
              ? cn(
                  "bg-(--header-advisor-avatar-background)/(--header-advisor-avatar-background-opacity)",
                  "rounded-(--header-advisor-avatar-border-radius)"
                )
              : cn(
                  "bg-(--message-advisor-avatar-background)/(--message-advisor-avatar-background-opacity)",
                  "rounded-(--message-advisor-avatar-border-radius)"
                )
          )}
        >
          <HeadsetIcon
            className={cn(
              isHeader
                ? cn(
                    "size-(--header-advisor-avatar-icon-size)",
                    "text-(--header-advisor-avatar-icon-color)/(--header-advisor-avatar-icon-color-opacity)"
                  )
                : cn(
                    "size-(--message-advisor-avatar-icon-size)",
                    "text-(--message-advisor-avatar-icon-color)/(--message-advisor-avatar-icon-color-opacity)"
                  )
            )}
          />
        </AvatarFallback>
      </Avatar>

      {isHeader && (
        <span
          className={cn(
            "absolute z-1 rounded-full",
            "size-(--header-advisor-avatar-indicator-size)",
            "ring-2 ring-(--header-background)",
            "bg-(--header-advisor-avatar-indicator-color)/(--header-advisor-avatar-indicator-color-opacity)",
            "bottom-(--header-advisor-avatar-indicator-offset-bottom) right-(--header-advisor-avatar-indicator-offset-right)"
          )}
        />
      )}
    </div>
  );
};
